import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import pen from "../../../Components/assets/icons/pen.png";
import basket from "../../../Components/assets/icons/basket.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import circle from "../../assets/icons/circle.png";
import rigth from "../../assets/icons/rigth.png";
import save from "../../assets/icons/save.png";
import cancel from "../../assets/icons/cross.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
// *******************toster****************************
import toast, { Toaster } from "react-hot-toast";

import { formatDate, timeShow } from "../../../utils/common";
import { Container, Row, Col, Button, Form, InputGroup } from "react-bootstrap";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import { DeletButton } from "../../common/Button";
library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    getDownloadDataExcel,
    Per_Page_Dropdown,
    IMG_URL,
  } = useContext(Context);
  const [onPageChange, setonPageChange] = useState(1);

  const [totalPages, settotalPages] = useState();

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}>
        {page}
      </Pagination.Item>
    );
  }

  const openPdfInNewTab = (data) => {
    window.open(IMG_URL + data, "_blank");
  };

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [searchDate, setSearchDate] = useState("");

  const getDataAll = async () => {
    const response = await getData(
      `/career/application-form?page=${onPageChange}&per_page=${perPage}&term=${search}&date=${
        searchDate ? formatDate(searchDate) : ""
      }`
    );
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.totalPages);
    // setCurrentPage(response?.data?.);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [
    changeStatus,
    perPage,
    reset,
    show,
    show1,
    search,
    searchDate,
    onPageChange,
  ]);

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/career/application-form/${id}`);
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value))
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(
        `/career/application-form/${recordToDeleteId}`
      );
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
    col11: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const HandleDownload = async () => {
    if (selectAllChecked.length == 0) {
      alert("Please Select Atleast One Record");
    } else {
      try {
        await getDownloadDataExcel(
          "/contact-us/downloads",
          selectAllChecked,
          "Contact us list"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header
          title={"Career Application Form"}
          link={"/employee/career/application-form"}
        />
        <section className="AdvanceDashboard">
          <div className="row ">
            <div className="col-lg-12">
              <div className="row MainRowsec">
                <section className="Tabels tab-radio tab-radio mt-3">
                  <div className="">
                    <div className="row">
                      <div className="d-flex">
                        <div className="add me-1">
                          <div className="dropdown"></div>
                        </div>

                        {/* <div className="add">
                      <Button
                        variant="success"
                        className="btn btn-view"
                        onClick={HandleDownload}
                      >
                        {" "}
                        <FontAwesomeIcon
                          icon="fa-solid fa-download"
                          className="me-2"
                        />
                        Download
                      </Button>
                    </div> */}
                      </div>
                      <div className="border-line my-3"></div>
                      <div className="row ">
                        <div className=" col-12"></div>
                        <div className=" col-12">
                          <div className="row align-items-end">
                            <div className=" col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                              <div className="num me-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Name/email"
                                  id=""
                                  value={search}
                                  onChange={(e) => {
                                    setSearch(e.target.value);
                                    handlePageChange(1);
                                  }}
                                />
                              </div>
                            </div>

                            <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                              <div className="num me-2">
                                <input
                                  type="date"
                                  className="form-control"
                                  id=""
                                  value={searchDate}
                                  onChange={(e) => {
                                    setSearchDate(e.target.value);
                                    handlePageChange(1);
                                  }}
                                  max={new Date().toISOString().split("T")[0]}
                                  onInput={(e) => {
                                    const inputValue = e.target.value;
                                    const [year, month, day] =
                                      inputValue.split("-");
                                    if (year && year.length > 4) {
                                      e.target.value = `${year.slice(0, 4)}-${
                                        month || ""
                                      }-${day || ""}`.replace(/-+$/, "");
                                    }
                                  }}
                                />
                              </div>
                            </div>
                            {/* <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-6 col-12 mb-2">
                                <Form.Label>Download Excel</Form.Label>
                              <FontAwesomeIcon
                                icon="fa-solid fa-file-lines"
                                className="pdf-icon"
                                variant="success"
                                // className="btn btn-view"
                                onClick={HandleDownload}
                              />
                            </div> */}
                            {/* <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-2 col-12 mb-2">
                              <div className="Search me-2">
                                <button
                                  type="button"
                                  onClick={getDataAll}
                                  className="btn btn-search btn btn-primary w-100"
                                >
                                  <img
                                    src={search1}
                                    className="search"
                                    alt=""
                                  />
                                </button>
                              </div>
                            </div> */}
                            <div className="col-xxl-1 col-xl-2  col-lg-2  col-md-2 col-12 mb-2">
                              <div className="Search-1">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSearch("");
                                    setSearchDate("");
                                    setReset(!reset);
                                  }}
                                  className="btn btn-reset w-100">
                                  Reset
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-line my-3"></div>
                    <div className="row mt-3">
                      <div className="data table-responsive">
                        <Table striped bordered hover responsive center>
                          <thead>
                            <tr className="">
                              {/* <th className="check round-check">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value="selectAll"
                                    checked={
                                      allChecked.length ===
                                      selectAllChecked.length
                                    }
                                    onChange={handleChange}
                                    id="selectAll"
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor="flexCheckChecked"
                                  ></label>
                                </div>
                              </th> */}
                              {visible.col1 && <th className="sr">Sr. No.</th>}
                              {visible.col2 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "20%" }}>
                                  Name
                                </th>
                              )}
                              {visible.col3 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "20%" }}>
                                  Email
                                </th>
                              )}
                              {visible.col4 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "20%" }}>
                                  Contact Number
                                </th>
                              )}
                              {visible.col5 && (
                                <th className="tax-name">Current location</th>
                              )}
                              {visible.col6 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "30%" }}>
                                  Current Organization
                                </th>
                              )}
                              {visible.col8 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "30%" }}>
                                  Current CTC
                                </th>
                              )}{" "}
                              {visible.col9 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "30%" }}>
                                  Total Experience
                                </th>
                              )}
                              {visible.col7 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "30%" }}>
                                  Inquiry Date
                                </th>
                              )}
                              {visible.col11 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "30%" }}>
                                  Inquiry For Job
                                </th>
                              )}
                              {visible.col10 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "30%" }}>
                                  Resume
                                </th>
                              )}
                              {
                                <th
                                  className="tax-name"
                                  style={{ width: "30%" }}>
                                  View
                                </th>
                              }
                              {
                                <th
                                  className="tax-name"
                                  style={{ width: "30%" }}>
                                  Delete
                                </th>
                              }
                              {/* {visible.col4 && <th className="active">Action</th>} */}
                            </tr>
                          </thead>
                          <tbody>
                            {data?.data?.data?.length > 0 ? (
                              data.data.data.map((d, index) => {
                                const paginatedIndex =
                                  (onPageChange - 1) * perPage + index + 1;
                                return (
                                  <tr className="" key={index}>
                                    {/* <td>
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value={d?.id}
                                        name="perselected"
                                        checked={selectAllChecked.includes(
                                          d?.id
                                        )}
                                        onChange={handleChange}
                                        id="flexCheckDefault"
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="flexCheckDefault"
                                      ></label>
                                    </div>
                                  </td> */}
                                    {visible.col1 && <td>{paginatedIndex}.</td>}{" "}
                                    {visible.col2 && <td>{d?.name}</td>}
                                    {visible.col3 && <td>{d?.email}</td>}
                                    {visible.col4 && <td>{d?.contact_no}</td>}
                                    {visible.col5 && (
                                      <td>{d?.current_location}</td>
                                    )}
                                    {visible.col6 && (
                                      <td>{d?.current_organization}</td>
                                    )}
                                    {visible.col8 && <td>{d?.current_ctc}</td>}{" "}
                                    {visible.col9 && <td>{d?.total_exp}</td>}
                                    {visible.col7 && (
                                      <td>{(d?.createdAt).split("T")[0]}</td>
                                    )}
                                    {visible.col11 && <td>{d?.job?.name}</td>}
                                    {visible.col10 && (
                                      <td>
                                        <div
                                          className="role-holder"
                                          onClick={() =>
                                            openPdfInNewTab(d?.resume)
                                          }>
                                          <object
                                            data={IMG_URL + d?.resume}
                                            type="application/pdf"
                                            width="100"
                                            height="100">
                                            <p>
                                              Browser Not Supported{" "}
                                              <a
                                                href={IMG_URL + d?.resume}
                                                target="_blank"
                                                rel="noopener noreferrer">
                                                Download PDF
                                              </a>
                                            </p>
                                          </object>
                                        </div>
                                      </td>
                                    )}
                                    {d.resume && (
                                      <td className="text-center">
                                        <FontAwesomeIcon
                                          onClick={() =>
                                            openPdfInNewTab(d.resume)
                                          }
                                          icon={faEye}
                                          className="viewEye"
                                        />
                                      </td>
                                    )}
                                    {
                                      <td className="text-center">
                                        <DeletButton
                                          showDeleteRecord={showDeleteRecord}
                                          id={d?.id}
                                          name={d?.name}
                                        />
                                      </td>
                                    }
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="15" className="text-center">
                                  Data not available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>{" "}
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <!-- Modal Delete --> */}
      <div className="upload-modal">
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          id="exampleModaldel"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true">
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h1 className="add-success text-center  mt-2">
                  Are you sure ?
                </h1>
                <p>
                  Do You Really Want to Delete These Record?
                  <br /> This Process CanNot Be Undone{" "}
                </p>
                <div className="button-holder text-center mt-2">
                  <button
                    className="btn btn-yes me-2"
                    onClick={handleDeleteRecord}>
                    Yes
                  </button>
                  <button className="btn btn-no" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
